module.exports = __webpack_public_path__ + "static/img/skyline.c045baf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/1x/skyline.png
// module id = o0dx
// module chunks = 1